import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SnackService } from './snack.service';
import { UserdataService } from './userdata.service';
import { CookieService } from 'ngx-cookie-service';
import { serverurl } from '../../environments/environment';
import { GdprService } from './gdpr.service';

@Injectable({
    providedIn: 'root'
})
export class AuthandregistryService {

    constructor(
        private http: HttpClient,
        private router: Router,
        private mysnack: SnackService,
        private userdata: UserdataService,
        private cookieService: CookieService,
        private gdpr: GdprService
    ) { }

    async confirmEmail(confirmId: string): Promise<any> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/confirm/${confirmId}`, { confirmId: confirmId })
                .subscribe({
                    next: (data: any) => {
                        this.mysnack.success(data.msg);
                        this.router.navigate(['home']);
                        resolve(true);
                    },
                    error: (err: any) => {
                        this.mysnack.error(err);
                        resolve(false);
                    }
                });

        })
    }
    async setNewPassword(resetId: string, password: string): Promise<any> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/setnewpw`, { resetId: resetId, password: password })
                .subscribe({
                    next: (data: any) => {
                        this.mysnack.success(data.msg);
                        if (data.userdata.token) {
                            this.saveAndRedirect(data);
                            this.router.navigate(['home']);
                            resolve(true);
                        }
                        resolve(true);
                    },
                    error: (err: any) => {
                        this.mysnack.error(err);
                        resolve(false);
                    }
                });

        })
    }
    async new2faCode(useremail: string): Promise<any> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/new2fa`, { email: useremail })
                .subscribe({
                    next: (data: any) => {
                        this.mysnack.success(data.msg);
                        resolve(data.verifyId);
                    },
                    error: (err: any) => {
                        this.mysnack.error(err);
                        resolve(false);
                    }
                });

        });
    }
    async verify2fa(verifyId: string, verifyCode: string): Promise<any> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/verify`, { verifyId: verifyId, verifyCode: verifyCode })
                .subscribe({
                    next: async (data: any) => {
                        this.saveAndRedirect(data);

                        let last = localStorage.getItem('ids_be_lastvisit');
                        if (last) this.router.navigate([last]);
                        else this.router.navigate(['home']);

                        resolve(true);
                    },
                    error: (err: any) => {
                        console.log(err);
                        this.mysnack.error(err);
                        resolve(false);
                    }
                });

        })
    }

    async doAutoLogin(): Promise<any> {
        let userId, apiKey;

        userId = localStorage.getItem('ids_be_userId');
        apiKey = localStorage.getItem('ids_be_apiKey');

        if (!userId || !apiKey) {
            return false;
        }

        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/autologin`, { userId: userId, apiKey: apiKey })
                .subscribe({
                    next: (data: any) => {
                        this.saveAndRedirect(data);

                        let last = localStorage.getItem('ids_be_lastvisit');
                        // if (last) this.router.navigate([last]);
                        this.router.navigate(['home']);

                        resolve(data);
                    }
                });

        })
    }

    async doLogin(email: string, password: string): Promise<any> {
        return await new Promise((resolve) => {

            this.http.post(`${serverurl}/auth/login`, { email: email, password: password })
                .subscribe({
                    next: (data: any) => {
                        this.router.navigate(['login/verify/' + data.verifyId]);
                        resolve(true);
                    },
                    error: (err: any) => {
                        console.log(err);

                        this.mysnack.error(err);
                        resolve(false);
                    }
                });

        })
    }
    async doLogOut() {
        return await new Promise((resolve) => {
            this.http.get(`${serverurl}/auth/logout`)
                .subscribe({
                    next: (data: any) => {
                        sessionStorage.clear();
                        localStorage.removeItem('ids_be_apiKey');
                        localStorage.removeItem('ids_be_userId');
                        localStorage.removeItem('ids_greet');
                        this.userdata.data.next(null);
                        this.cookieService.delete('ids_be_session');
                        resolve(true);
                        this.router.navigate(['login']);
                    }
                });

        })
    }
    protected async saveAndRedirect(data: any) {
        localStorage.setItem('ids_be_apiKey', data.userdata.apiKey);
        localStorage.setItem('ids_be_userId', data.userdata.id);
        localStorage.removeItem('ids_be_loginemail')
        this.userdata.updateUserData(data.userdata);
    }

    async doPwForgotten(email: string): Promise<any> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/pwforgotten`, { email: email })
                .subscribe({
                    next: (data: any) => {
                        resolve(true);
                    },
                    error: (err: any) => {
                        this.mysnack.error(err);
                        resolve(false);
                    }
                });

        })
    }

    async doPwReset(resetid: string, password: string): Promise<any> {
        return await new Promise((resolve) => {
            this.http.post(`${serverurl}/auth/setnewpw`, { resetid: resetid, password: password })
                .subscribe({
                    next: (data: any) => {
                        this.mysnack.success({ headline: "Success", text: "The password was reset successfully." });
                        resolve(true);
                    },
                    error: (err: any) => {
                        this.mysnack.error(err);
                        resolve(false);
                    }
                });

        })
    }

    async doRegister(email: string, password: string): Promise<any> {
        return await new Promise(async (resolve) => {
            this.http.post(`${serverurl}/auth/register`, { email: email, password: password, lang: 'en' })
                .subscribe({
                    next: (data: any) => {
                        this.saveAndRedirect(data);
                        this.mysnack.success(data.msg);
                        resolve(true);
                    },
                    error: (err: any) => {
                        this.mysnack.error(err);
                        resolve(false);
                    }
                });

        })
    }
}
